'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniqueIllustrationNames = getUniqueIllustrationNames;
exports.getIllustrationNamePropType = getIllustrationNamePropType;

var _react = require('react');

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var illustrationNames = void 0;
var propType = void 0;

function getUniqueIllustrationNames() {
  if (!illustrationNames) {
    /* global process */
    illustrationNames = process.env.NODE_ENV === 'production' ? [] : Object.keys(require('ui-images/metadata').illustrations);
  }
  return illustrationNames;
}

function getIllustrationNamePropType() {
  if (!propType) {
    propType = _react.PropTypes.oneOf(getUniqueIllustrationNames());
  }

  return (0, _createChainablePropType2.default)(propType, 'illustrationName');
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/propTypes/illustrationName.js
// module id = 207
// module chunks = 3 4 5